import { PageProps } from 'gatsby';
import { useIntl } from 'gatsby-plugin-react-intl';
import * as React from 'react';
import { SEO } from '../components/seo/seo';
import { useSiteMetadata } from '../hooks/useSiteMetadata';
import { MainTemplate } from '../templates/main/main';
import { EuProgramBanner } from '../ui/pages/home/eu-program-banner/eu-program-banner';
import { Highlights } from '../ui/pages/home/highlights/highlights';
import { StayInTouch } from '../ui/pages/home/stay-in-touch/stay-in-touch';
import { WeOffer } from '../ui/pages/home/we-offer/we-offer';
import { WelcomeSection } from '../ui/pages/home/welcome-section/welcome-section';

const IndexPage = ({ location }: PageProps) => {
  const intl = useIntl();
  const { siteTitle, siteTitleAlt, siteUrlWithTrailingSlash, social } =
    useSiteMetadata();

  const schemaMarkup = {
    '@context': 'https://schema.org',
    '@type': 'Corporation',
    name: siteTitle,
    alternateName: siteTitleAlt,
    url: siteUrlWithTrailingSlash,
    logo: `${siteUrlWithTrailingSlash}static/a5e9628c6b27f5c9b34c6911644247f0/e9b55/Logo-min.png`,
    sameAs: [siteUrlWithTrailingSlash, social.facebook, social.youtube],
  };

  return (
    <MainTemplate>
      <SEO
        location={location}
        title={intl.formatMessage({ id: 'home.seo_title' })}
        description={intl.formatMessage({ id: 'home.seo_description' })}
        schemaMarkup={schemaMarkup}
      />
      <WelcomeSection />
      <Highlights />
      <WeOffer />
      <StayInTouch />
      <EuProgramBanner />
    </MainTemplate>
  );
};

export default IndexPage;
